import { render, staticRenderFns } from "./TabelaResultadosMembro.vue?vue&type=template&id=5ebe3959&scoped=true&"
import script from "./TabelaResultadosMembro.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosMembro.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosMembro.vue?vue&type=style&index=0&id=5ebe3959&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe3959",
  null
  
)

export default component.exports